import { render, staticRenderFns } from "./ProductItem2.vue?vue&type=template&id=01053adc"
import script from "./ProductItem2.vue?vue&type=script&lang=js"
export * from "./ProductItem2.vue?vue&type=script&lang=js"
import style0 from "./ProductItem2.vue?vue&type=style&index=0&id=01053adc&prod&lang=css"
import style1 from "./ProductItem2.vue?vue&type=style&index=1&id=01053adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports